import type { RouteRecordRaw } from 'vue-router'

const viewModules = import.meta.glob('../views/**/index.vue')
const layoutModules = import.meta.glob('../layouts/*.vue')

const getComponent = (dir: 'views' | 'layouts', path: string) => {
  return dir === 'views' ? viewModules[`../${dir}/${path}/index.vue`] : layoutModules[`../${dir}/${path}.vue`]
}

const routes: Array<RouteRecordRaw> = [
  // 主页
  { path: '/', name: 'home', component: getComponent('views', 'home') },
  /** 接入文档 */
  { path: '/document', name: 'document', component: getComponent('views', 'home') },
  // 联系我们
  { path: '/contact', name: 'contact', component: getComponent('views', 'contact') },
  // 资质认证审核中
  {
    path: '/controlCenter/accountManagement/certificationReview',
    name: 'certificationReview',
    component: getComponent('views', 'certificationReview')
  },
  // 服务协议
  { path: '/serviceAgreement', name: 'serviceAgreement', component: getComponent('views', 'serviceAgreement') },
  // 公告
  { path: '/notice', name: 'notice', component: getComponent('views', 'notice') },
  // 公告详情
  { path: '/notice/:id', name: 'noticeDetail', component: getComponent('views', 'notice/noticeDetail') },
  // 管理中心
  {
    path: '/controlCenter',
    name: 'controlCenter',
    component: getComponent('layouts', 'controlCenterLayout'),
    redirect: '/controlCenter/gameManagement/gameManagementMainEntance',
    children: [
      // 资质认证页面（未申请、审核失败）
      {
        path: 'certification',
        name: 'certification',
        component: getComponent('views', 'certification')
      },
      // 账号管理
      {
        path: 'accountManagement/accountInfo',
        name: 'accountInfo',
        component: getComponent('views', 'accountManagement/accountInfo')
      },
      {
        path: 'accountManagement/subAccountInfo',
        name: 'subAccountInfo',
        component: getComponent('views', 'accountManagement/subAccountInfo')
      },
      {
        path: 'accountManagement/subAccountManagement',
        name: 'subAccountManagement',
        component: getComponent('views', 'accountManagement/subAccountManagement')
      },
      {
        path: 'accountManagement/authenticationInfo',
        name: 'authenticationInfo',
        component: getComponent('views', 'accountManagement/authenticationInfo')
      },
      {
        path: 'accountManagement/ipWhitelist',
        name: 'ipWhitelist',
        component: getComponent('views', 'accountManagement/ipWhitelistManagement')
      },
      // 游戏管理
      {
        path: 'gameManagement/gameManagementMainEntance',
        name: 'gameManagementMainEntance',
        component: getComponent('views', 'gameManagement/gameManagementMainEntance')
      },
      {
        path: 'gameManagement/reservationMaterial',
        name: 'reservationMaterial',
        component: getComponent('views', 'gameManagement/reservationMaterial')
      },
      {
        path: 'gameManagement/toPerfectInfo',
        name: 'toPerfectInfo',
        component: getComponent('views', 'gameManagement/gameDetailsInfo/toPerfectInfo')
      },
      {
        path: 'gameManagement/toUpdateInfo',
        name: 'toUpdateInfo',
        component: getComponent('views', 'gameManagement/gameDetailsInfo/toUpdateInfo')
      },
      {
        path: 'gameManagement/toCheckInfo',
        name: 'toCheckInfo',
        component: getComponent('views', 'gameManagement/gameDetailsInfo/toCheckInfo')
      },
      {
        path: 'gameManagement/x7ShopManagement',
        name: 'x7ShopManagement',
        component: getComponent('views', 'gameManagement/x7ShopManagement')
      },
      {
        path: 'gameManagement/x7ShopTypeDetail',
        name: 'x7ShopTypeDetail',
        component: getComponent('views', 'gameManagement/x7ShopTypeDetail')
      },
      // 结算中心
      {
        path: 'settlementCenter/settlementCenterMainEntance',
        name: 'settlementCenterMainEntance',
        component: getComponent('views', 'settlementCenter/settlementCenterMainEntance')
      },
      // 数据中心
      {
        path: 'dataCenter/:pageType',
        name: 'dataCenterMainEntance',
        component: getComponent('views', 'dataCenter'),
        props: true
      },
      //汇率记录
      // {
      //   path: 'exchangeRateRecord',
      //   name: 'exchangeRateRecord',
      //   component: getComponent('views', 'exchangeRateRecord')
      // }
      // 游戏测试
      {
        path: 'gameManagement/gameTest/:ngid',
        name: 'gameTest',
        component: getComponent('views', 'gameManagement/gameTest'),
        props: true
      },
      // 礼包管理
      {
        path: 'gameManagement/giftManagement/:ngid',
        name: 'giftManagement',
        component: getComponent('views', 'gameManagement/giftManagement'),
        props: true
      }
    ]
  },
  // 游戏审核
  {
    path: '/controlCenter/gameManagement/gameReview',
    name: 'gameReview',
    component: getComponent('views', 'gameManagement/gameReview')
    // children: [
    //   { path: 'gameReview', name: 'gameReview', component: getComponent('views', 'gameManagement/gameReview') }
    // ]
  },
  {
    path: '/controlCenter/settlementCenter/settlementCenterDocList',
    name: 'settlementCenterDocList',
    component: getComponent('views', 'settlementCenter/settlementCenterDocList')
  }
]

export default routes
